import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "toolbar-card mb-4" }
const _hoisted_4 = { class: "toolbar-left" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = { class: "toolbar-right" }
const _hoisted_8 = { class: "search-shell" }
const _hoisted_9 = ["value", "placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "code-pill"
}
const _hoisted_11 = {
  key: 6,
  class: "d-flex justify-content-center gap-2"
}
const _hoisted_12 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.t("income_page.income_list")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t("income_page.toolbar_description")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", {
              value: _ctx.searchQuery,
              type: "text",
              class: "form-control toolbar-search",
              placeholder: _ctx.t('income_page.search_placeholder'),
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchQuery', ($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_9),
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1))
          ]),
          _createVNode(_component_router_link, {
            to: "/create-income",
            class: "btn style-one btn-sm d-flex align-items-center gap-2"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-add-circle-line" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.t("create_income")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.incomes,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.paginationConfig,
        locale: _ctx.tableLocale,
        class: "income-table"
      }, {
        bodyCell: _withCtx(({ column, record, text }) => [
          (column.key === 'ref')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.ref || _ctx.t("income_page.not_available")), 1))
            : (column.key === 'date')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(record.date)), 1)
                ], 64))
              : (column.key === 'warehouse')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(record.warehouse?.name || record.warehouse_name || _ctx.t("income_page.not_available")), 1)
                  ], 64))
                : (column.key === 'category')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(record.category?.name || record.category_name || _ctx.t("income_page.not_available")), 1)
                    ], 64))
                  : (column.key === 'amount')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(" $" + _toDisplayString(Number(record.amount || 0).toFixed(2)), 1)
                      ], 64))
                    : (column.key === 'status')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 5,
                          class: _normalizeClass(["status-badge", Number(record.status ?? 1) === 1 ? 'status-active' : 'status-inactive'])
                        }, _toDisplayString(Number(record.status ?? 1) === 1 ? _ctx.t("income_page.active") : _ctx.t("income_page.inactive")), 3))
                      : (column.key === 'actions')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_router_link, {
                              to: `/edit-income/${record.id}`,
                              class: "icon-btn",
                              title: _ctx.t('income_page.edit')
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "ri-pencil-line" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["to", "title"]),
                            _createElementVNode("button", {
                              class: "icon-btn danger",
                              title: _ctx.t('income_page.delete'),
                              onClick: ($event: any) => (_ctx.$emit('delete', record))
                            }, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("i", { class: "ri-delete-bin-6-line" }, null, -1)
                            ]))], 8, _hoisted_12)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            _createTextVNode(_toDisplayString(text || _ctx.t("income_page.not_available")), 1)
                          ], 64))
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "locale"])
    ])
  ]))
}